<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Thu hồi sim`"/>
        <v-flex xs12 sm12 md8 lg6 xl6 offset-md2 offset-lg3 offset-xl3>
          <v-card>
            <v-container>
              <v-card-text class="pa-10">
                <v-form v-model="form.isValid" ref="form">
                  <v-autocomplete
                    v-model="form.sourceId"
                    label="Thu về"
                    :items="dealers"
                    item-text="name"
                    item-value="id"
                    :rules="[validate.required]"
                  ></v-autocomplete>
                  <v-text-field v-model="form.refCode" label="Mã phiếu xuất hàng"></v-text-field>
                  <v-text-field v-model="form.remark" label="Ghi chú"></v-text-field>
                  <v-textarea
                    auto-grow
                    label="Danh sách Sim (ICCID)"
                    v-model="form.iccIdsStr"
                    hint="Mỗi số ICCID cần xuống dòng để phân biệt"
                    :rules="[validate.required]"
                  ></v-textarea>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="clear()">Nhập lại</v-btn>
                <v-btn color="primary" dark @click="submit()" :loading="isLoading">Thu hồi sim</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as Utils from '@/utils';
import AppBar from '@/components/appbar';
import validate from '@/utils/validate';

export default {
  components: {
    AppBar
  },

  data () {
    return {
      validate: validate,
      isLoading: false,
      form: {
        isValid: false,
        iccIdsStr: '',
        iccIds: [],
        sourceId: '',
        refCode: '',
        remark: ''
      }
    };
  },

  computed: {
    ...mapGetters(['accounts']),
    dealers () {
      return this.accounts.filter(a => a.isDistributor || a.isDealer);
    }
  },

  watch: {
    'form.iccIdsStr' () {
      if (this.form.iccIdsStr) {
        let arr = this.form.iccIdsStr.split('\n');
        this.form.iccIds = [];
        arr.map(a => {
          if (a) this.form.iccIds.push(a.trim());
          return 0;
        });
      }
    }
  },

  mounted () {
    if (this.accounts.length === 0) {
      this.getAccounts(Utils.pagination);
    }
  },

  methods: {
    ...mapActions(['getAccounts', 'returnSims']),
    clear () {
      this.form = {
        iccIdsStr: '',
        iccIds: [],
        sourceId: '',
        refCode: '',
        remark: ''
      };
      this.$refs.form.reset();
    },
    submit () {
      if (this.form.isValid) {
        this.isLoading = true;
        this.returnSims(this.form)
          .then(_ => {
            this.isLoading = false;
            window.getApp.showMessage('Thu hồi sim thành công');
            // this.clear();
            window.history.back();
          })
          .catch(err => {
            this.isLoading = false;
            let msg = '';
            if (err === 'ERR_INVALID_PERMISSION') {
              msg =
                'Không thể thu hồi sim thuộc quyền sở hữu của tài khoản khác';
            } else {
              msg = 'Thu hồi sim thất bại, vui lòng thử lại';
            }
            window.getApp.showMessage(msg, 'error');
          });
      } else {
        this.$refs.form.validate();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/sim/return.vue